import { Card, CardContent, CardHeader, Stack, Typography } from '@mui/material'
import { useMemo } from 'react'
import { useDashboardContext } from '../../contexts/DashboardContextProvider'
import BigStatCurrency from '../BigStatCurrency'

export default function OutstandingCommission() {
  const { fetching, outstandingCommission } = useDashboardContext()
  const content = useMemo(() => {
    if (fetching) {
      return <Typography>Loading...</Typography>
    }
    if (outstandingCommission === 0) {
      return <Typography>No outstanding commission</Typography>
    }
    return <BigStatCurrency value={outstandingCommission} color="success" />
  }, [fetching, outstandingCommission])
  return (
    <Card>
      <CardHeader title="Outstanding Commission" subheader="Sum of POs without payments" />
      <CardContent>
        <Stack alignItems="center">{content}</Stack>
      </CardContent>
    </Card>
  )
}
